// extracted by mini-css-extract-plugin
export var buttons = "bt_cn";
export var container = "bt_b";
export var image = "bt_k";
export var innerText = "bt_fC";
export var logo = "bt_bn";
export var p = "bt_fm";
export var section = "bt_j";
export var short = "bt_fn";
export var tall = "bt_fD";
export var textContainer = "bt_b2";